import * as React from 'react';

import { SavedCreditCard } from '@models/Account';

export interface PaymentCreditCardProperties {
  readonly defaultSavedCreditCard?: SavedCreditCard;
  readonly savedCreditCard?: SavedCreditCard;
  readonly savedCreditCards: Array<SavedCreditCard>;
  readonly setSavedCreditCard: (creditCard?: SavedCreditCard) => void;
}

export class PaymentCreditCard extends React.PureComponent<PaymentCreditCardProperties> {
  public componentDidMount(): void {
    if (this.props.defaultSavedCreditCard) {
      this.props.setSavedCreditCard(this.props.defaultSavedCreditCard);
    }
  }

  public render(): JSX.Element {
    if (this.props.savedCreditCards == null || this.props.savedCreditCards.length === 0) {
      return <h4>Proceed to complete payment with First Data.</h4>;
    }

    const options = this.props.savedCreditCards.map((scc: SavedCreditCard, i: number) => (
      <option key={i} value={scc.name}>{`${scc.name} (${scc.account.creditCardLastFour})`}</option>
    ));

    return (
      <>
        <div className="row">
          <div className="form-control col-xl-4 col-lg-5 col-md-6">
            <label>Saved Credit Cards</label>
            <select defaultValue="" onChange={this.handleSavedCreditCardSelect}>
              <option value="" />
              {options}
            </select>
          </div>
        </div>
        <h4>Select a saved card or proceed to complete payment with First Data.</h4>
      </>
    );
  }

  private handleSavedCreditCardSelect = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    this.props.setSavedCreditCard(this.props.savedCreditCards!.find(scc => scc.name === event.currentTarget.value));
  };
}



// WEBPACK FOOTER //
// ./src/payment/_components/payment-credit-card.component.tsx